import { render, staticRenderFns } from "./serviceSettings.vue?vue&type=template&id=64278353"
import script from "./serviceSettings.vue?vue&type=script&lang=js"
export * from "./serviceSettings.vue?vue&type=script&lang=js"
import style0 from "./serviceSettings.vue?vue&type=style&index=0&id=64278353&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports